<template>
  <div class="lay" v-loading="loading">
    <el-checkbox-group v-model="checkList">
      <el-checkbox class="row" @change="handleChecked(item, hasIds.ids.includes(item.id))" v-for="item in datas"
        :label="item" :key="item.id" :checked="hasIds.ids.includes(item.id)">{{ item.name }}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import _ from 'lodash'
import Checkbox from './checkbox'

export default {
  inject: ['removeIds', 'hasIds', 'multiple'],
  components: {
    Checkbox
  },
  props: {
    datas: Array,
    loading: Boolean
  },
  data() {
    return {
      checkList: [],
      checked: true
    }
  },
  computed: {
    removeOptions() {
      return this.removeIds.ids
    }
  },
  watch: {
    removeOptions(ids) {
      const keeps = _.filter(this.checkList, (item, i) => (!ids.includes(item.id)))
      this.checkList = keeps
    }
  },
  methods: {
    handleChecked(item, checked) {
      // fixed element checkbox bug
      // if (checked) {
      //   let bugList = this.checkList
      //   bugList = _.uniqWith(bugList, _.isEqual)
      //   this.checkList = _.filter(bugList, (item) => item.id !== id)
      // }
      if (!this.multiple) {
        this.checkList = [item]
      }
      this.$emit('onChecked', this.checkList, checked)
    }
  }
}
</script>

<style lang="scss" scoped>
.lay {
  max-height: 50vh;
  overflow: auto;
}
.row {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.row:hover {
  background-color: #f5f5f5;
}
:deep(.el-checkbox) {
  margin-right: 0;
}
</style>
